import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { fetchConfiguration, selectConfiguration } from '../redux/configuration'

export default function useConfiguration() {
  const dispatch = useDispatch()

  const { data: configuration, isLoading } = useSelector(selectConfiguration)

  const getConfigurations = useCallback((slug: string) => dispatch(fetchConfiguration({ slug })), [])

  return {
    isLoading,
    configuration,
    getConfigurations,
  }
}
